import { Route } from "react-router-dom";
import { Revenues } from "./Revenues";

export const getRevenuesScene = () => (
  <Route path="revenues">
    <Route path="*" element={<Revenues />} />
  </Route>
);
